/* global Modernizr */
import $ from 'jquery'
import { isURL } from './helpers'
import { MessageOverlay } from './message-overlay'
import { Popup } from './popup'
import { mountTooltips } from './tooltips'

export const Forms = {
  HOOK_LOADING_FORM: '.js-form-loading',
  HOOK_FIELD_MANAGE: '.js-field-manage',
  HOOK_FIELD_MANAGE_ROW: '.js-field-manage-row',
  HOOK_FIELD_MANAGE_ADD: '.js-field-manage-add',
  HOOK_FIELD_MANAGE_REMOVE: '.js-field-manage-remove',
  HOOK_COPY_TEXT: '.js-copy-text',
  HOOK_RESET_FIELD: '.js-reset-field',
  HOOK_RESET_BUTTON: '.js-reset-button',

  init: function () {
    Forms.creditCardType()

    // Copy text to clipboard
    if (!Modernizr.touchevents) {
      mountTooltips(Forms.HOOK_COPY_TEXT, { title: 'Click to copy' })
      $(document).on('click', Forms.HOOK_COPY_TEXT, Forms.copyText)
    }

    $(document).on('submit', '#popup.help form', function (event) {
      event.preventDefault()
      Forms.helpForm($(this))
      return false
    })

    $(document).on('submit', '.js-inbound-form', function (event) {
      event.preventDefault()
      Forms.inboundForm($(this))
    })

    $(document).on('submit', Forms.HOOK_LOADING_FORM, Forms.formLoading)
    $(document).on('click', Forms.HOOK_FIELD_MANAGE_ADD, Forms.addManageField)
    $(document).on(
      'click',
      Forms.HOOK_FIELD_MANAGE_REMOVE,
      Forms.removeManageField
    )
    $(Forms.HOOK_FIELD_MANAGE).each(function () {
      Forms.checkManageFields($(this))
    })

    // Reset field
    $(document).on('keyup', Forms.HOOK_RESET_FIELD, Forms.resetFieldKeyup)
    $(document).on('click', Forms.HOOK_RESET_BUTTON, Forms.resetField)
  },

  copyText: function (event) {
    event.preventDefault()
    $(this).copyText()
  },

  formLoading: function () {
    $(this).addClass('u-is-loading')
  },

  creditCardType: function () {
    function getCardType(num) {
      if (/^5[1-5]/.test(num)) {
        return 'mastercard'
      } else if (/^4/.test(num)) {
        return 'visa'
      } else if (/^3[47]/.test(num)) {
        return 'amex'
      }
      return undefined
    }

    $('.cc-num').on('keyup blur', function () {
      const type = getCardType($(this).val().replace(/[ -]/g, '')),
        icon = $('.cc-type li'),
        className = 'current'

      icon.removeClass(className)

      if (type !== undefined) {
        $('.cc-' + type).addClass(className)
        $('input#cc-type').val(type)
      }
    })
  },

  helpForm: function (form) {
    if (Forms.helpFormValidation(form)) {
      form.addClass('u-is-loading')

      // POST
      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: form.serialize(),
      })
        .done(function () {
          form.removeClass('u-is-loading')
          Forms.helpFormSuccess(form)
          Popup.refresh()
        })
        .fail(function () {
          form.removeClass('u-is-loading')
          form.prepend(
            '<p class="error">Something went wrong. Please try again.</p>'
          )
        })
    }
  },

  helpFormValidation: function (form) {
    const topic = form.find('select'),
      details = form.find('textarea'),
      error = '<div class="c-form-row_error" />'

    // Validate inputs
    if (topic.val() !== '' && details.val() !== '') {
      return true
    } else {
      const topicParent = topic.parents('.c-form-row'),
        detailParent = details.parents('.c-form-row')

      // Check topic
      if (topic.val() === '') {
        topicParent.addClass('error')

        if (!topicParent.find('.c-form-row_error').length) {
          $(error).html('<p>Please select a topic</p>').appendTo(topicParent)
        }
      } else {
        topicParent.removeClass('error')
        topicParent.find('.c-form-row_error').remove()
      }

      // Check details
      if (details.val() === '') {
        detailParent.addClass('error')

        if (!detailParent.find('.c-form-row_error').length) {
          $(error)
            .html('<p>Please provide details about your issue or question</p>')
            .appendTo(detailParent)
        }
      } else {
        detailParent.removeClass('error')
        detailParent.find('.c-form-row_error').remove()
      }

      return false
    }
  },

  helpFormSuccess: function (form) {
    form.html(
      "<p>Your message has been sent. We'll get back to you as soon as possible</p>"
    )
  },

  inboundForm: function ($form) {
    const $field = $form.find('input[type="url"]'),
      $formRow = $form.find('.c-form-row').first(),
      $formError = $form.find('.c-form-row_error'),
      $submitBtn = $form.find('input.u-btn')

    function beginLoading() {
      $form.addClass('u-is-loading')
      $submitBtn.prop('disabled', true)
    }

    function endLoading() {
      $form.removeClass('u-is-loading')
      $submitBtn.prop('disabled', false)
    }

    function validateForm() {
      const errors = []

      if ($field.val() === '') {
        errors.push('Please enter your inbound webhook URL')
      }

      if (!isURL($field.val())) {
        errors.push('Please enter a valid URL')
      }

      return errors
    }

    function checkHookURL(url, callback) {
      const testUrl = $field.data('test-url')

      const payload = {
        webhook: {
          url: url,
          test_trigger: 'inbound',
        },
      }

      $.ajax({
        type: 'POST',
        url: testUrl,
        data: payload,
      })
        .done(function (data) {
          callback(data.success ? null : data.message)
        })
        .fail(xhr => {
          callback(xhr.statusText)
        })
    }

    function updateSettings(callback) {
      $.ajax({
        type: 'PATCH',
        url: $form.attr('action'),
        data: $form.serialize(),
      })
        .done(function () {
          callback(null)
        })
        .fail(xhr => {
          callback(xhr.statusText)
        })
    }

    beginLoading()

    const errors = validateForm()

    if (errors.length === 0) {
      checkHookURL($field.val(), err => {
        if (err) {
          endLoading()
          return Forms.showError($formRow, err)
        }

        updateSettings(err => {
          if (err) {
            endLoading()
            return Forms.showError($formRow, err)
          }

          MessageOverlay.show('Inbound webhook URL saved.')

          $formRow.removeClass('error')
          $formError.remove()
          endLoading()
        })
      })
    } else {
      const rowError = '<div class="c-form-row_error" />',
        errorMessage = `<p>${errors[0]}</p>`

      $formRow.addClass('error')

      // Check for existing error container
      if (!$formError.length) {
        $(rowError).html(errorMessage).appendTo($formRow)
      } else {
        $formError.html(errorMessage)
      }

      endLoading()
    }
  },

  showError: function ($formRow, errorMessage) {
    if (!$formRow.length) {
      throw new Error(
        `Failed to show error "${errorMessage}. $formRow not found"`
      )
    }

    const existingError = $formRow.find('.c-form-row_error')
    $formRow.addClass('error')

    // Check if there's an existing error
    if (existingError.length) {
      existingError.find('p').html(errorMessage)
      existingError.pulsate()
    } else {
      // Set error message
      errorMessage =
        errorMessage || 'There was an error with making this request.'
      const formError =
        '<div class="c-form-row_error"><p>' + errorMessage + '</p></div>'

      $formRow.find('input').attr('aria-invalid', 'true')
      $formRow.append(formError)
    }
  },

  removeError: function ($formRow) {
    $formRow.removeClass('error').find('.c-form-row_error').remove()
  },

  addManageField: function (event) {
    event.preventDefault()

    const $parent = $(this).parents(Forms.HOOK_FIELD_MANAGE).first()

    // Clone the first field
    const $fieldRow = $parent.find(Forms.HOOK_FIELD_MANAGE_ROW).first().clone()

    // Wipe the input value and remove the label
    $fieldRow.find('input').val('')
    $fieldRow.find('.c-form-row_label').text('')

    // Remove form errors
    $fieldRow.removeClass('error').find('.c-form-row_error').remove()
    $fieldRow.find('input').removeClass('is-invalid')

    // Append it and set focus
    $fieldRow
      .insertAfter($parent.find(Forms.HOOK_FIELD_MANAGE_ROW).last())
      .find('input')
      .first()
      .focus()
    Forms.checkManageFields($parent)
  },

  removeManageField: function (event) {
    event.preventDefault()

    const $parent = $(this).parents(Forms.HOOK_FIELD_MANAGE).first()

    // Clone the field label
    const $label = $parent
      .find('.c-form-row')
      .first()
      .find('.c-form-row_label')
      .html()

    // Remove the field
    $(this).parents(Forms.HOOK_FIELD_MANAGE_ROW).remove()

    // Move the  label to the first field
    $parent
      .find(Forms.HOOK_FIELD_MANAGE_ROW)
      .first()
      .find('.c-form-row_label')
      .html($label)
    Forms.checkManageFields($parent)
  },

  checkManageFields: function ($parent) {
    const limit = $parent.data('limit') || 15

    const $add = $parent.find(Forms.HOOK_FIELD_MANAGE_ADD)
    const $remove = $parent.find(Forms.HOOK_FIELD_MANAGE_REMOVE)
    const $rows = $parent.find(Forms.HOOK_FIELD_MANAGE_ROW)

    // Hide the "remove" button if there's only one field
    $rows.length > 1
      ? $remove.removeClass('hidden')
      : $remove.addClass('hidden')

    $rows.length >= limit ? $add.addClass('hidden') : $add.removeClass('hidden')
  },

  resetFieldKeyup: function () {
    if ($(this).val()) {
      $(Forms.HOOK_RESET_BUTTON).showMe()
    } else {
      $(Forms.HOOK_RESET_BUTTON).hideMe()
    }
  },

  resetField: function (event) {
    event.preventDefault()

    $(this).hideMe()
    const $target = $($(this).data('target'))

    if ($target.hasClass('js-autocomplete')) {
      $target.autocomplete('val', '').focus()
    } else {
      $target.val('').trigger('focus')
    }
  },
}

$(Forms.init)
